import { render, staticRenderFns } from "./HelpTool.vue?vue&type=template&id=5a5a8524&scoped=true"
import script from "./HelpTool.vue?vue&type=script&lang=js"
export * from "./HelpTool.vue?vue&type=script&lang=js"
import style0 from "./HelpTool.vue?vue&type=style&index=0&id=5a5a8524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5a8524",
  null
  
)

export default component.exports